import { useCallback } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { IRule, IRuleExecution } from '@scale/shared/types/ruleEngine/rule';
import { makeStyles } from 'design-system/styles';
import ExecutionTableFooter from 'react-scale/corp/components/RuleEngine/ExecutionTableFooter';
import RuleExecutionRow from 'react-scale/corp/components/RuleEngine/RuleExecutionRow';
import { useQueryClient } from 'react-query';
function RuleExecutionTable(props: {
  rules?: IRule[];
  executions: IRuleExecution[];
  selectedPage: number;
  setSelectedPage: (page: number) => void;
  displayUtcTime?: boolean;
  ruleExecutionsKey: string[];
}) {
  const { rules, executions, selectedPage, setSelectedPage, displayUtcTime, ruleExecutionsKey } =
    props;
  const classes = styles();

  const queryClient = useQueryClient();

  const invalidateRuleExecutions = useCallback(() => {
    queryClient.invalidateQueries(ruleExecutionsKey);
  }, [queryClient, ruleExecutionsKey]);

  return (
    <div className={classes.executionTable}>
      <TableContainer>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>{rules ? 'Rule' : ''}</TableCell>
              <TableCell align="right">Started At</TableCell>
              <TableCell style={{ paddingLeft: 0 }}>{displayUtcTime ? '(UTC)' : ''}</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Execution ID</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {executions.map(execution => (
              <RuleExecutionRow
                label={rules && rules.find(r => r._id === execution.rule)?.name}
                key={execution._id}
                ruleExecution={execution}
                displayUtcTime={displayUtcTime}
                invalidateRuleExecutions={invalidateRuleExecutions}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ExecutionTableFooter
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
        lastPage={executions.length < 10}
      />
    </div>
  );
}

const styles = makeStyles({
  executionTable: {
    boxShadow: '0px 10px 20px 0px #6B72801A; px -10px 20px 0px #6B72800D',
    background: 'white',
    borderRadius: '1rem',
    height: 'min-content',
    maxHeight: '100%',
    width: '100%',
    maxWidth: '1000px',
    margin: '0 auto',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    border: '1px solid rgba(224, 224, 224, 1)',
  },
});

export default RuleExecutionTable;
